import axios from 'axios';
import qs from 'qs';

class Api {
  constructor() {
    this.params = qs.parse(window.location.search.replace('?', ''));
    this.axios = axios.create({
      baseURL: '/api',
      headers: {
        authorization: `Bearer ${this.params.token}`,
      }
    });
    this.columnOptionsCache = {};
    this.columnChoiceOptionsCache = {};
  }

  async getTableOptions() {
    const { data } = await this.axios.get('/tables');
    return data;
  }

  async getTableColumnOptions(tableName) {
    if (!this.columnOptionsCache[tableName]) {
      this.columnOptionsCache[tableName] = this.axios.get(`/tables/${tableName}/columns`);
    }
    const { data } = await this.columnOptionsCache[tableName];
    return data;
  }

  async getTableColumnChoiceOptions(tableName, column) {
    if (!this.columnChoiceOptionsCache[tableName]) {
      this.columnChoiceOptionsCache[tableName] = {};
    }
    if (!this.columnChoiceOptionsCache[tableName][column]) {
      this.columnChoiceOptionsCache[tableName][column] = this.axios.get(`/tables/${tableName}/columns/${column}/choices`);
    }
    const { data } = await this.columnChoiceOptionsCache[tableName][column];
    return data;
  }

  async getRules() {
    const { data } = await this.axios.get('/rules');
    return data;
  }

  async saveRules(rules) {
    const { data } = await this.axios.post('/rules', { rules });
    return data;
  }

  async getVisitorTypeOptions() {
    const { location } = this.params;
    const { data } = await this.axios.get('/visitor-types', { params: { location } });
    return data;
  }

  // Get appropriate Envoy callback URL for validation on setup completion
  async getReactCloseURL() {
    let res = await this.axios.get('/get-close-url');
    return res.data;
  }
}

export default Api;
